import { Action as ActionType } from "@iva/store-utils";
import { ErrorPayload, IoState } from "#store/types";
import { Action, DatasourceEnum } from "#services/pilotService/types";

/*******************************************************************************
 * types and interfaces
 ******************************************************************************/

interface Operator {
    query: string;
}

export enum FilterOperatorType {
    EQUAL = "=",
    GREATER_THAN = ">",
    LESS_THAN = "<",
    GREATER_OR_EQUAL = ">=",
    LESS_OR_EQUAL = "<=",
}
export type FilterOperator = Operator & {
    column: string;
    value?: string;
    operator?: "=" | ">" | "<" | ">=" | "<=";
};
export type PilotFilterBody = FilterOperator & {
    datasource: DatasourceEnum;
    maxInterpretations: number;
};

export type FacetOperator = Operator & {
    column: string;
};
export type PilotFacetBody = FacetOperator & {
    datasource: DatasourceEnum;
    maxInterpretations: number;
};

export type PilotSupersetBody = Operator & {
    datasource: DatasourceEnum;
    maxInterpretations: number;
};

export class NlOperation implements Operator {
    query = "";
    datasource: DatasourceEnum = DatasourceEnum.cordis;
    maxInterpretations = 10;
    maxResultsPerInterpretation = 100;
    nlToSqlInterpreter?: ("valuenet" | "nalir+" | "soda")[];
}

// Action types definition
export enum ActionIdentifiers {
    FETCH_ACTION_STARTED = "@@actions/FETCH_ACTION_STARTED",
    FETCH_ACTION_FAILED = "@@actions/FETCH_ACTION_FAILED",
    FETCH_ACTION_SUCCEEDED = "@@actions/FETCH_ACTION_SUCCEEDED",
    FETCHED_LIST_FROM_SERVER = "@@actions/CREATE_MULTIPLE",
    PUT_QUERY_STARTED = "@@action/PUT_QUERY_STARTED",
    PUT_QUERY_SUCCEEDED = "@@actions/PUT_QUERY_SUCCEEDED",
    PUT_QUERY_FAILED = "@@actions/PUT_QUERY_FAILED",
}

// Actions definition
export type FetchActionStartedActionType = ActionType<
    ActionIdentifiers.FETCH_ACTION_STARTED,
    number
>;
export type FetchActionSucceededActionType = ActionType<
    ActionIdentifiers.FETCH_ACTION_SUCCEEDED,
    Action
>;
export type FetchActionFailedActionType = ActionType<
    ActionIdentifiers.FETCH_ACTION_FAILED,
    ErrorPayload
>;
export type PutActionStartedActionType = ActionType<
    ActionIdentifiers.PUT_QUERY_STARTED,
    string
>;
export type PutActionSucceededActionType = ActionType<
    ActionIdentifiers.PUT_QUERY_SUCCEEDED,
    Action
>;
export type PutActionFailedActionType = ActionType<
    ActionIdentifiers.PUT_QUERY_FAILED,
    ErrorPayload
>;
export type CreateMultipleActionType = ActionType<
    ActionIdentifiers.FETCHED_LIST_FROM_SERVER,
    Action[]
>;
export type ActionsActionTypes =
    | FetchActionStartedActionType
    | FetchActionSucceededActionType
    | FetchActionFailedActionType
    | CreateMultipleActionType
    | PutActionFailedActionType
    | PutActionStartedActionType
    | PutActionSucceededActionType;

/*******************************************************************************
 * Reducer related stuff
 ******************************************************************************/

// State definition
export interface ActionsState {
    readonly actions: { [key: number]: IoState<Action> };
    // readonly query: string;
    // readonly pending: boolean[];
    // readonly requestId: string;
    // readonly tableResults: IQueryTableResult[];
}
